<template>
    <ul class="list avatar-list" :class="{'flex-no-wrap': props.noWrap, 'flex-row-reverse': props.rtl}">
        <li v-for="i in props.max" :key="i" :style="{'z-index': props.max + 2}">
            <skeleton rounded-full :width="props.size" :height="props.size"/>
        </li>
    </ul>
</template>

<script setup lang="ts">

const props = withDefaults(defineProps<{
	size: number,
	max: number,
	noWrap?: boolean,

	// By default, the avatars are displayed in a row with the first entry on the very left. If rtl is set to true, the first entry is on the very right.
	rtl?: boolean
}>(), {
	size: 34,
	max: 4
});
</script>
<style>
.list.avatar-list {
  display: flex;
  flex-wrap: wrap;
}
.list.avatar-list:not(.flex-row-reverse) > *:not(:first-child) {
  margin-left: -8px;
}
.list.avatar-list.flex-row-reverse > *:not(:last-child) {
  margin-left: -8px;
}
.list.avatar-list > .none + * {
  margin-left: 0;
}
.list.avatar-list li, .list.avatar-list .list-item {
  padding: 0;
  margin-bottom: 3px;
  margin-top: 3px;
  border: 2px solid white;
  border-radius: 100%;
  overflow: hidden;
}
</style>